import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import {
    CoreSelectors,
    SuperStore,
    TsStudioSelectors,
    UserActions,
    UserSelectors
} from '@bilancio/root-store';
import { ButtonComponent } from '@bilancio/ui';
import { DxPopoverModule } from 'devextreme-angular/ui/popover';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-note-rilascio',
    templateUrl: './note-rilascio.component.html',
    styleUrls: ['./note-rilascio.component.scss'],
    imports: [CommonModule, DxPopoverModule, ButtonComponent]
})
export class NoteRilascioComponent {
    @Input() target: ElementRef;

    @Input() set isVisible(isVisible: boolean) {
        this._isVisible = isVisible;
        this.isVisibleChange.emit(this._isVisible);
    }

    get isVisible(): boolean {
        return this._isVisible;
    }

    @Output() onReleaseNoteClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter();

    ultimaVersioneLetta$ = this.store.select(
        UserSelectors.getLastVersionReaded
    );
    preferences$ = this.store.select(UserSelectors.getPreferences);
    isIntegration$ = this.store.select(TsStudioSelectors.getIsIntegration);
    feVersion$ = this.store.select(CoreSelectors.getVersionFrontEnd);

    private _isVisible: boolean;

    constructor(private readonly store: SuperStore) {
        this.isVisible = false;
    }

    onButtonReleaseNoteClick(lastVersion: string): void {
        this.onReleaseNoteClick.emit();
        this.store.dispatch(UserActions.updateLastVersion({ lastVersion }));
    }
}
